<template>
    <div>
        <main id="documentMetadataPrint" role="main">

            <div class="container">

<!--                <a class="btn btn-primary text-white mb-4 noPrint" @click="print()"><i class="fa fa-print"></i> Natisni</a>-->

                <div class="row noPrint">
                    <div class="col-md-12 mb-0">
                        <h2 v-if="Object.keys(nodeData).length > 0">
                            <i class="fa" :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i> {{nodeData.properties["rma:origionalName"]}}
                        </h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-5">
                        <div class="row" v-if="Object.keys(nodeData).length > 0">

                                <div class="col-md-12 metadataSidebar" ng-if="nodeData">

                                        <div class="row mb-1">
                                            <div class="col-md-12">
                                                <h5 class="mt-1">{{$t('text.globals.documentInformation')}} <b>{{nodeData.properties["rma:origionalName"]}}</b></h5>
                                            </div>
                                        </div>

                                        <div class="row">

                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.name')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.properties["rma:origionalName"]}}</dd>
                                                </dl>
                                            </div>
                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.title')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.properties["cm:title"]}}</dd>
                                                </dl>
                                            </div>

                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.id')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.id}}</dd>
                                                </dl>
                                            </div>


                                            <div class="col-12">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.description')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.properties["cm:description"]}}</dd>
                                                </dl>
                                            </div>

                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.author')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.properties["cm:author"]}}</dd>
                                                </dl>
                                            </div>


                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.mimeTypeName')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.content.mimeTypeName ? nodeData.content.mimeTypeName : nodeData.content.mimeType}}</dd>
                                                </dl>
                                            </div>
                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.sizeInBytes')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.content.sizeInBytes | prettyBytes}}</dd>
                                                </dl>
                                            </div>

                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.createdByUserDisplayName')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.createdByUser.displayName}}</dd>
                                                </dl>
                                            </div>
                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.createdAt')}}:</dt>
                                                    <dd class="col-md-12">{{moment(nodeData.createdAt).local().format("DD. MM. YYYY HH:mm:ss")}}
                                                    </dd>
                                                </dl>
                                            </div>

                                            <div class="col-4">
                                                <dl class="row">
                                                    <dt class="col-md-12">{{$t('text.metadata.modifiedByUserDisplayName')}}:</dt>
                                                    <dd class="col-md-12">{{nodeData.modifiedByUser.displayName}}</dd>
                                                </dl>
                                            </div>
                                            <div class="col-4">
                                                <dl class="row mb-0">
                                                    <dt class="col-md-12">{{$t('text.metadata.modifiedAt')}}:</dt>
                                                    <dd class="col-md-12">{{moment(nodeData.modifiedAt).local().format("DD. MM. YYYY HH:mm:ss")}}
                                                    </dd>
                                                </dl>
                                            </div>

                                        </div>
                                        <div class="row mb-0">
                                            <div class="col-md-12">
                                                <hr/>
                                            </div>
                                        </div>

                                        <div class="row">
                                             <div class="col-md-12">
                                                <h5 class="mt-1 mb-2">{{$t('text.globals.documentMetadata')}}</h5>
                                            </div>
                                        </div>

                                        <div role="tablist" class="metadataList">

                                            <div class="mb-1 nodeTypeSection"
                                                 v-for="(item, index) in nodeData.types" :key="index" v-if="item.title!='E-podpis'">

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6>{{item.title}}</h6>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-12">

                                                            <div class="row">
                                                                <div class="col-4"
                                                                     v-for="(innerItem, innerIndex) in item.properties"
                                                                    :class="innerItem.name === 'EH:lokacija_hrambe' ? 'col-12' : 'col-4'"
                                                                >


                                                                    <dl class="row">
                                                                        <dt class="col-sm-12">{{innerItem.title}}:</dt>
                                                                        <dd class="col-sm-12">
                                                                        <span v-if="innerItem.dataType === 'd:date'">
                                                                            {{moment(nodeData.properties[innerItem.name]).local().format("DD. MM. YYYY")}}
                                                                        </span>
                                                                            <span v-else-if="innerItem.dataType === 'd:datetime'">
                                                                            {{moment(nodeData.properties[innerItem.name]).local().format("DD. MM. YYYY HH:mm:ss")}}
                                                                        </span>
                                                                            <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                            <span v-if="nodeData.properties[innerItem.name]"><i
                                                                                    class="fa fa-check-circle"></i> {{$t('text.globals.yes')}}</span>
                                                                            <span v-if="!nodeData.properties[innerItem.name]"><i
                                                                                    class="fa fa-times-circle"></i> {{$t('text.globals.no')}}</span>
                                                                        </span>
                                                                            <span v-else>
                                                                               {{nodeData.properties[innerItem.name] ? nodeData.properties[innerItem.name] : '/'}}
                                                                        </span>
                                                                        </dd>
                                                                    </dl>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                       <hr/>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="mb-1 nodeTypeSection"
                                                 v-for="(item, index) in nodeData.types" :key="index" v-if="item.title==='E-podpis'">

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6>{{item.title}} <span v-if="item.title=='E-podpis'">({{podpisi.length}})</span></h6>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="row">
                                                        <div class="col-md-12">

                                                            <div v-for="(podpis,idx) in podpisi" class="card mb-1">

                                                                <div class="card-body">

                                                                    <small
                                                                           class="d-inline-block mb-2" style="margin-left: -5px;"><b>{{$t('text.metadata.signature')}}
                                                                        #{{idx+1}}</b></small>


                                                                    <div class="row">
                                                                        <div class="col-4"
                                                                             v-for="(innerItem, innerIndex) in item.properties"
                                                                             :class="'col-4'">

                                                                            <dl class="row">
                                                                                <dt class="col-sm-12">
                                                                                    {{innerItem.title}}:
                                                                                </dt>
                                                                                <dd class="col-sm-12">
                                                                            <span v-if="innerItem.dataType === 'd:date'">
                                                                                {{moment(podpis[innerItem.name]).local().format("DD. MM. YYYY")}}
                                                                            </span>
                                                                                    <span v-else-if="innerItem.dataType === 'd:datetime'">
                                                                                {{moment(podpis[innerItem.name]).local().format("DD. MM. YYYY HH:mm:ss")}}
                                                                            </span>
                                                                                    <span v-else-if="innerItem.dataType === 'd:boolean'">
                                                                                <span v-if="podpis[innerItem.name]"><i
                                                                                        class="fa fa-check-circle"></i> {{$t('text.globals.yes')}}</span>
                                                                                <span v-if="!podpis[innerItem.name]"><i
                                                                                        class="fa fa-times-circle"></i> {{$t('text.globals.no')}}</span>
                                                                            </span>
                                                                                    <span v-else>
                                                                                   {{podpis[innerItem.name] ? podpis[innerItem.name] : '/'}}
                                                                            </span>
                                                                                </dd>
                                                                            </dl>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <hr/>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="mb-1 nodeTypeSection">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6>{{$t('text.metadata.components')}} <small>({{components.length}})</small></h6>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">

                                                        <ol class="pl-3">
                                                            <li v-for="component in components"
                                                                :key="component.entry.id" style="font-size: 12px;" class="font-weight-bold">
                                                                <div class="text-left py-0 pl-2">
                                                                    <span>{{component.entry.properties['cm:title']}}</span>
                                                                </div>
                                                            </li>
                                                        </ol>

                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <hr/>
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="mb-1 nodeTypeSection">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <h6>{{$t('text.metadata.attachments')}} <small>({{linksToLeadingDocument.length}})</small></h6>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">

                                                        <ol class="pl-3">
                                                            <li v-for="linkToLeadingDocument in linksToLeadingDocument"
                                                                :key="linkToLeadingDocument.entry.id" style="font-size: 12px;" class="font-weight-bold">
                                                                <div class="text-left py-0 pl-2">
                                                                    <span>{{linkToLeadingDocument.entry.properties['cm:title']}}</span>
                                                                </div>
                                                            </li>
                                                        </ol>

                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <hr/>
                                                    </div>
                                                </div>

                                            </div>



                                        </div>

                                    </div>

                        </div>
                    </div>


                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';


    export default {
        name: 'DocumentDetails',
        components: {
            SidebarNavigation,
            Loading
        },

        data() {
            return {
                fileId: this.$route.params.id, //f3bb5d08-9fd1-46da-a94a-97f20f1ef208 (doc) //0957142f-a388-494b-bcd6-ea6f9496a26d (odt) //de0b8c74-4fa2-416f-9bde-4c81e7f7d28f (pdf)
                sites: [],
                user: {},
                error: '',
                nodeData: {},
                allMetadataOptions: [],
                components: [],
                linksToLeadingDocument: [],
                printPopupShown: false,
                podpisi: []
            };
        },

        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        mounted() {
            const _this = this;

            let p1 =  _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 =  _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1, p2]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
                _this.getNode(_this.fileId);
            });

        },

        computed: {
        },

        methods: {

            async getNode(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {

                        // before setting nodeData replace code list ids with readable content
                        _this.nodeData = _this.$globalFunctions.getReadableDocumentMetadataCodeListValues(_this.allMetadataOptions, res.data.entry);


                        // join separated signature data to array of signature objects
                        let epodpisi = null;
                        let steviloEpodpisov = 0;

                        _.each(_this.$store.getters.getAlfrescoDictionary, function(v, k){
                            if(v.name === 'EH:e_podpis') {
                                console.log("v", v);
                                epodpisi = v.properties;
                            }
                        });

                        steviloEpodpisov =  _this.nodeData.properties['EH:stevilo_podpisov'];
                        delete epodpisi['EH:stevilo_podpisov'];


                        for(let i = 0; i < steviloEpodpisov; i++) {
                            let podpis = {};
                            _.forOwn(epodpisi, function (v, k){
                                console.log("k", k, "v", _this.nodeData.properties[k][i]);
                                podpis[k] = _this.nodeData.properties[k][i];
                            });
                            _this.podpisi.push(podpis);
                        }
                        console.log("PODPISI", _this.podpisi);

                        _this.getComponents();
                        _this.getLinksToLeadingDocument();

                        let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {

                            if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0,3) === 'EH:') {
                                return true
                            } else {
                                return false
                            }
                        });

                        _this.nodeData.types = types;
                        console.log("types", types);


                        console.log("node data: ", _this.nodeData);

                        // if(!_this.printPopupShown) {
                        //     _this.print();
                        // }



                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });


            },

            getComponents() {
                const _this = this;

                let query = {
                    "query": {
                        "query": "EH:komponenta_povezave_na_dokumente:\"" + _this.nodeData.id + "\""
                    },
                    "include": [
                        "properties"
                    ]
                };

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        _this.components = res.data.list.entries;
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });

            },

            getLinksToLeadingDocument() {
                const _this = this;

                let query = {
                    "query": {
                        "query": "EH:povezave_na_vodilne_dokumente:\"" + _this.nodeData.id + "\""
                    },
                    "include": [
                        "properties"
                    ]
                };

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        _this.linksToLeadingDocument = res.data.list.entries;
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });

            },

            setupPrintProperties(orientation) {
                let style = document.createElement('style');
                document.head.appendChild(style);
                style.innerHTML = '@page {size: A4 ' + orientation + '}';
            },

            print() {
                const _this = this;

                _this.setupPrintProperties('portrait');
                _this.printPopupShown = true;

                setTimeout(function () {

                    if(navigator.userAgent.toLowerCase().indexOf('chrome') > -1){   // Chrome Browser Detected?
                        window.PPClose = false;                                     // Clear Close Flag
                        window.onbeforeunload = function(){                         // Before Window Close Event
                            if(window.PPClose === false){                           // Close not OK?
                                return this.$t('text.documentMetadataPrint.pageLeaveWarning');
                            }
                        }
                        window.print();                                             // Print preview
                        window.PPClose = true;                                      // Set Close Flag to OK.
                    } else {
                        window.print();
                    }


                    window.onafterprint = function(event) {
                        _this.$router.replace("/dokument/" + _this.fileId);
                    };
                    // setTimeout(function () {
                    //     _this.$router.replace("/dokument/" + _this.fileId);
                    // }, 10);


                }, 100)

            }

        }


    };
</script>

<style scoped>
    @media print {
        @page {
            size: A4 portrait;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/DocumentMetadataPrint.vue